module.exports = __webpack_public_path__ + "img/scene5-3.ee3d196a.png";